import React from "react";
import { Box, Typography } from "@mui/material";
import FinOpsFilters from "./FinOpsFilters";

const FinOpsHeader = ({ orgAccountMap, selectedOrgCode, selectedAccountNumber, onOrgChange, onAccountChange }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 3,
        flexWrap: { xs: "wrap", md: "nowrap" },
        gap: 2,
      }}
    >
      <Box sx={{ flex: 1, minWidth: { xs: "100%", md: "auto" } }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 700,
            color: "text.primary",
            mb: 0.5,
            fontSize: { xs: "1.75rem", md: "2rem" },
          }}
        >
          Customer Summary
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            fontSize: "0.875rem",
          }}
        >
          Financial Operations insights and analytics for your customers
        </Typography>
      </Box>

      {/* Filters on the right */}
      {orgAccountMap && Object.keys(orgAccountMap).length > 0 && (
        <Box sx={{ flexShrink: 0 }}>
          <FinOpsFilters
            orgAccountMap={orgAccountMap}
            selectedOrgCode={selectedOrgCode}
            selectedAccountNumber={selectedAccountNumber}
            onOrgChange={onOrgChange}
            onAccountChange={onAccountChange}
          />
        </Box>
      )}
    </Box>
  );
};

export default FinOpsHeader;
